import type { ReactNode } from "react";
import { BricksRail } from "./BricksRail";

/** 데스크톱 rail 폭. fixed 요소(하단 CTA 등)가 rail을 덮지 않게 맞출 때도 같은 값을 쓴다 (`md:left-[260px]`) */
export const BRICKS_RAIL_WIDTH_PX = 260;

/**
 * 인증된 화면의 공통 배치. 하나의 children 트리를 유지하고 CSS로만 배치를 바꾼다.
 * - 767px 이하: rail 없음
 * - 768px 이상: 좌측 rail 260px + 본문(min-width 0, 최대 1200px 가운데 정렬)
 *   본문 좌우 여백은 768~1023 16px, 1024 이상 32px. 각 화면은 모바일 여백만 자체 관리한다.
 */
export function BricksShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh md:bg-gray-10">
      <aside className="hidden fixed inset-y-0 left-0 bg-white border-r border-gray-200 md:block w-[260px] z-dropdown">
        <BricksRail />
      </aside>
      <div className="min-w-0 md:pl-[260px]">
        <div className="mx-auto w-full md:max-w-[1200px] md:px-4 lg:px-8">{children}</div>
      </div>
    </div>
  );
}
